import React from 'react';
import { motion } from 'framer-motion';
import '../css/skill.css';

export default function Skill() {

    // Smooth Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.04,
                delayChildren: 0.15,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, scale: 0.85, y: 25 },
        visible: {
            opacity: 1,
            scale: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    const labelVariants = {
        hidden: { opacity: 0, x: -40 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.6,
                ease: [0.25, 0.46, 0.45, 0.94]
            }
        }
    };

    const skillData = [
        { src: "images/c.png", alt: "C", title: "C" },
        { src: "images/c++.png", alt: "c++", title: "c++" },
        { src: "images/python.png", alt: "Python", title: "Python" },
        { src: "images/pandas.png", alt: "Pandas", title: "Pandas" },
        { src: "images/numpy.png", alt: "numpy", title: "Numpy" },
        { src: "images/django.png", alt: "Django", title: "Django" },
        { src: "images/flask.png", alt: "flask", title: "flask" },
        { src: "images/fastapi.png", alt: "fastapi", title: "fastapi" },
        { src: "images/mysql.png", alt: "mysql", title: "mysql" },
        { src: "images/php.png", alt: "PHP", title: "PHP" },
        { src: "images/mongodb.png", alt: "mongodb", title: "mongodb" },
        { src: "images/firebase-2.png", alt: "Firebase", title: "Firebase" },
        { src: "images/oracle.png", alt: "oracle", title: "oracle" },
        { src: "images/html.png", alt: "HTML", title: "HTML" },
        { src: "images/css.png", alt: "CSS", title: "CSS" },
        { src: "images/javascript.png", alt: "JavaScript", title: "JavaScript" },
        { src: "images/typescript.png", alt: "typescript", title: "Typescript" },
        { src: "images/bootstrap.png", alt: "bootstrap", title: "bootstrap" },
        { src: "images/tailwindcss.png", alt: "Tailwind CSS", title: "Tailwind CSS" },
        { src: "images/react.png", alt: "React", title: "React" },
        { src: "images/docker.png", alt: "docker", title: "docker" },
        { src: "images/linux.png", alt: "linux", title: "linux" },
        { src: "images/github.png", alt: "github", title: "github" },
        { src: "images/git.png", alt: "git", title: "git" },
        { src: "images/figma.png", alt: "figma", title: "figma" },
        { src: "images/jira.png", alt: "jira", title: "jira" },
        { src: "images/lucidchart.png", alt: "lucidchart", title: "lucidchart" },
        { src: "images/visual studio code.png", alt: "visual-studio-code", title: "visual studio code" },
        { src: "images/jupyter.png", alt: "jupyter", title: "Jupyter" },
        { src: "images/anaconda.png", alt: "anaconda", title: "Anaconda" }
    ];

    const softSkills = [
        "Communication", "Problem Solving", "Team Collaboration",
        "Adaptability", "Time Management", "Critical Thinking",
        "Creativity", "Self-Motivation"
    ];

    const languages = [
        "English – Professional", "German – Beginner",
        "Punjabi – Mid", "Urdu – Native"
    ];

    return (
        <>
            {/* SKILL-SET SECTION */}
            <motion.section
                className="skill-set"
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] }}
            >

                {/* Skills Block */}
                <div className="skill-block">
                    <motion.div
                        className="block-label block-label-skill"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={labelVariants}
                    >
                        Technical Expertise
                    </motion.div>
                    <motion.div
                        className="block-content"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, margin: "-50px" }}
                        variants={containerVariants}
                    >
                        {skillData.map((skill, index) => (
                            <motion.div
                                key={index}
                                className="skill-logo"
                                variants={itemVariants}
                                whileHover={{ scale: 1.15, rotate: 5 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <img src={skill.src} alt={skill.alt} title={skill.title} />
                            </motion.div>
                        ))}
                    </motion.div>
                </div>

                {/* Divider */}
                <motion.div
                    className="horizontal-divider"
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeInOut" }}
                />

                {/* Soft Skills Block */}
                <div className="soft-skill-block">
                    <motion.div
                        className="block-label block-label-soft-skill"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={labelVariants}
                    >
                        Soft Skills
                    </motion.div>
                    <motion.div
                        className="soft-skills-wrapper"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={containerVariants}
                    >
                        {softSkills.map((skill, index) => (
                            <motion.p
                                key={index}
                                variants={itemVariants}
                                whileHover={{ scale: 1.08, y: -3 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                {skill}
                            </motion.p>
                        ))}
                    </motion.div>
                </div>

                {/* Divider */}
                <motion.div
                    className="horizontal-divider"
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeInOut" }}
                />

                {/* Languages Block */}
                <div className="language-block" style={{ padding: 0, marginTop: '50px' }}>
                    <motion.div
                        className="block-label-language"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={labelVariants}
                    >
                        Languages
                    </motion.div>
                    <motion.div
                        className="block-content-language"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={containerVariants}
                    >
                        {languages.map((lang, index) => (
                            <motion.p
                                key={index}
                                variants={itemVariants}
                                whileHover={{ scale: 1.08, y: -3 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                {lang}
                            </motion.p>
                        ))}
                    </motion.div>
                </div>

                {/* Divider */}
                <motion.div
                    className="horizontal-divider"
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeInOut" }}
                />
            </motion.section>
        </>
    );
}
